<div class="modal fade" :id="elementId" tabindex="-1" role="dialog" :aria-labelledby="elementId + 'Label'" aria-hidden="true">
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" :id="elementId + 'Label'">Link Customer to Depot Discount Groups</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="onModalCloseClick">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="table-responsive">
                    <table class="table table-hover mb-0">
                        <thead>
                            <tr>
                                <th>
                                    Name
                                </th>
                                <th>Discount Amount</th>
                                <th>Depot</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="depotDiscountGroup in depotDiscountGroups">
                                <td>
                                    {{ depotDiscountGroup.name }}
                                </td>
                                <td>
                                    {{ depotDiscountGroup.depot }}
                                </td>
                                <td>
                                    {{ depotDiscountGroup.discountAmountAsString }}
                                </td>
                                <td>
                                    <input type="checkbox" v-model="depotDiscountGroup.linkedToCustomer" @change="onLinkedToCustomerCheckboxChange(depotDiscountGroup)">
                                </td>
                            </tr>
                        </tbody>
                    </table>
               </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" data-dismiss="modal" @click="onModalSaveClick" :disabled="loading">SAVE</button>
                <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="onModalCloseClick" :disabled="loading">CLOSE</button>
            </div>
        </div>
    </div>
</div>